module.exports = __webpack_public_path__ + "static/media/664.17431f3f.webp";